import { popoverAnatomy as parts } from '@chakra-ui/anatomy'
import { cssVar } from '@chakra-ui/theme-tools'

const $popperBg = cssVar('popper-bg')
const $arrowBg = cssVar('popper-arrow-bg')
const $arrowShadowColor = cssVar('popper-arrow-shadow-color')

const baseStylePopper = {
  zIndex: 10
}

const baseStyleContent = {
  [$popperBg.variable]: 'var(--front)',
  bg: $popperBg.reference,
  [$arrowBg.variable]: $popperBg.reference,
  [$arrowShadowColor.variable]: 'var(--border)',
  width: 'xs',
  border: '1px solid',
  borderColor: 'inherit',
  borderRadius: 'md',
  boxShadow: 'lg',
  zIndex: 'inherit',
  _focus: {
    outline: 0,
    boxShadow: 'outline'
  }
}

const baseStyleHeader = {
  px: 3,
  py: 2,
  borderBottomWidth: '1px'
}

const baseStyleBody = {
  px: 3,
  py: 2
}

const baseStyleFooter = {
  px: 3,
  py: 2,
  borderTopWidth: '1px'
}

const baseStyleCloseButton = {
  position: 'absolute',
  borderRadius: 'md',
  top: 1,
  insetEnd: 2,
  padding: 2
}

export const Popover = {
  parts: parts.keys,
  baseStyle: {
    popper: baseStylePopper,
    content: baseStyleContent,
    header: baseStyleHeader,
    body: baseStyleBody,
    footer: baseStyleFooter,
    arrow: {},
    closeButton: baseStyleCloseButton
  }
}
